import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { Database } from '@/types/database.types';

export type AccountSession =
  Database['public']['Functions']['list_my_active_sessions']['Returns'][number];

export function useAccountSessions(enabled = true) {
  return useQuery({
    queryKey: ['account-sessions'],
    enabled,
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('list_my_active_sessions');
      if (error) throw error;
      return data ?? [];
    },
  });
}
